import { createFileRoute, Navigate } from "@tanstack/react-router"

export const Route = createFileRoute("/_base/_auth/settings/subscription/")({
  component: RouteComponent,
})

function RouteComponent() {
  return <Navigate to="/settings/subscription/usage" replace />
}
